import React, { useRef, useEffect, useState } from 'react'
import { VideoStyles } from 'styles/style';
import { watermarkImageWithText } from 'helpers/Watermark';
import { useAuth } from 'hooks/auth';
import { api } from 'supabase/database/api.ts';

const VideoContent = ({
    vid_key,
 }) => {
    const videoRef = useRef(null);
	const { user } = useAuth();
	const [userId, setUserId] = useState("");

    useEffect(() => {
    	// Disable fullscreen button (and potentially other controls)
    	const videoElement = videoRef.current;
    	if (videoElement) {
    		videoElement.controlsList = "nodownload"; // Remove download button
    		// Attempt to remove the fullscreen button (may not work in all browsers)
    		const fullscreenButton = videoElement.querySelector(
    			".vjs-fullscreen-control"
    		);
    		if (fullscreenButton) {
    			fullscreenButton.style.display = "none";
    		}
    		// Detect and prevent fullscreen attempts via API
    		videoElement.addEventListener("webkitendfullscreen", () => {
    			if (document.webkitIsFullScreen) {
    				document.webkitExitFullscreen();
    			}
    		});
    	}
    }, []);
	
	useEffect(() => {
    	async function fetchUserInfo() {
		  if (!user || !user.email) return;
    	  const data = await api.authQueries.getUserInfo({ email: user.email })
    	  setUserId(data[0].registration_number)
    	};

		fetchUserInfo();
	}, [user]);

	useEffect(() => {
		const setWatermarkWidth = () => {
			try {
				const elements = document.getElementsByClassName("vjs-watermark");
				if (elements.length > 0) {
					const watermark = elements[0];
					if (userId !== "") {
						watermark.setAttribute(
							"src",
							watermarkImageWithText(userId)
						);
						watermark.setAttribute(
							"style",
							"min-width: 80% !important; pointer-events: none;"
						);
					}
				}
			} catch (error) {
				// Silently handle watermark errors
			}
		};

		if (userId) {
			const timeoutId = setTimeout(setWatermarkWidth, 2000);
			return () => clearTimeout(timeoutId);
		}
	}, [userId])

	useEffect(() => {
		const interval = setInterval(() => {
			const player = document.querySelector('.vjs-has-started');

			if (player) {

				// Prevent duplicate injections
				if (!document.querySelector(".vjs-rewind-button")) {
					const rewindButton = document.createElement("button");
					rewindButton.className = "vjs-control vjs-rewind-button";
					rewindButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ccc" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rewind-icon lucide-rewind"><path d="M12 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 12 18z"/><path d="M22 6a2 2 0 0 0-3.414-1.414l-6 6a2 2 0 0 0 0 2.828l6 6A2 2 0 0 0 22 18z"/></svg>`;
					rewindButton.onclick = () => {
						const video = player.querySelector("video");
						video.currentTime -= 10;
					};
					player.querySelector(".vjs-control-bar")?.appendChild(rewindButton);
				}

				if (!document.querySelector(".vjs-forward-button")) {
					const forwardButton = document.createElement("button");
					forwardButton.className = "vjs-control vjs-button vjs-forward-button";
					forwardButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ccc" stroke="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-fast-forward-icon lucide-fast-forward"><path d="M12 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 12 18z"/><path d="M2 6a2 2 0 0 1 3.414-1.414l6 6a2 2 0 0 1 0 2.828l-6 6A2 2 0 0 1 2 18z"/></svg>`;
					forwardButton.onclick = () => {
						const video = player.querySelector("video");
						video.currentTime += 10;
					};
					player.querySelector(".vjs-control-bar")?.appendChild(forwardButton);
				}

				clearInterval(interval); // Done
			}
		}, 500); // check every 500ms

		return () => clearInterval(interval);
	}, []);

    return (
        <VideoStyles.VideoContainer key={vid_key}>
	    	<smartvideo
	    		ref={videoRef} // Add this ref
	    		className="swarm-fluid"
	    		controls
	    		playsInline
	    		webkit-playsinline="true"
	    		src={
	    			vid_key?.length === 11
	    				? `https://www.youtube.com/embed/${vid_key}?playsinline=1`
	    				: `swarmify://${vid_key}`
	    		}
	    	></smartvideo>
        </VideoStyles.VideoContainer>
    )
}

export default VideoContent